import AppleAppStoreLogo from '~/assets/img/apple-app-store.svg';
import { ExternalLink } from '~/components/Button';
import { Stars } from '~/components/DownloadAppBlock';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

const APPS_FLYER_LINK = 'https://thesolesupplier.onelink.me/BPkz/nmeeyt06';

export default function AppNudge() {
  const fireAppLink = useNavigationLinkInteraction('notification_nudge');

  return (
    <>
      <div className="flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-black p-4 lg:hidden">
        <span className="w-full text-center text-base text-white">
          Get notifications faster with our app
        </span>
        <ExternalLink
          variant="green-cta"
          href={APPS_FLYER_LINK}
          onClick={() =>
            fireAppLink(APPS_FLYER_LINK, 1, { label: 'Download the app now' })
          }
          className="flex w-full items-center justify-center gap-2"
        >
          <div className="w-[84px]">
            <img
              alt="Download on the App Store"
              src={AppleAppStoreLogo}
              loading="lazy"
            />
          </div>
          <span className="text-sm font-bold text-black">
            Download the app now
          </span>
        </ExternalLink>
      </div>
      <div className="hidden w-full items-center justify-center gap-6 rounded-lg bg-black p-4 lg:flex xl:p-6">
        <div className="flex flex-col gap-4">
          <span className="text-[26px] text-white">
            Get notifications faster with our app
          </span>
          <div className="flex w-full items-center justify-start gap-4">
            <div className="w-[96px]">
              <img
                alt="Download on the App Store"
                src={AppleAppStoreLogo}
                loading="lazy"
              />
            </div>
            <div className="flex gap-2">
              <Stars />
              <span className="text-white">4.8</span>
            </div>
          </div>
        </div>
        <div className="flex aspect-square w-[112px] shrink-0 items-center justify-center">
          <img
            alt="QR Code to download the app"
            src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/download_app_notification_set_qr_code.png"
            loading="lazy"
          />
        </div>
      </div>
    </>
  );
}
